import { all, call, put, fork, takeEvery, select } from 'redux-saga/effects';
import {
    fetchSecuritysSuccess,
    showSecurityMessage,
    onSaveSecuritySuccess,
    onDeleteSecuritySuccess,
    addFavouriteSecuritySuccess,
} from 'actions/security';
import {
    ON_SAVE_SECURITY,
    FETCH_ALL_SECURITY,
    ON_DELETE_SECURITY,
    ADD_FAVOURITE_SECURITY,
} from 'constants/ActionTypes';
import { fetchDataRequest, addOrUpdateDataRequest, updateDataRequest, deleteDataRequest  } from 'services/ApiService';
import { apiErrorMessageFormatter } from 'services/errorService';
import { ORGID_PATH_PARAM } from 'constants/api';

const currentOrg = (state) => state.orgs.selectedOrg;
const getSecurityList = (state) => state.securitys.allSecurity;

export function* fetchSecuritys() {
    try {
        const selectedOrg = yield select(currentOrg);
        const fetchedSecuritys = yield call(
            fetchDataRequest,
            'securitys',
            [ORGID_PATH_PARAM],
            [selectedOrg ?.id]
        ) || [];
        yield put(fetchSecuritysSuccess(fetchedSecuritys));
    } catch (error) {
        yield put(showSecurityMessage(apiErrorMessageFormatter(error)));
    }
}

export function* deleteSecurity({ payload }) {
    try {
        // payload should be the securityId
        const selectedOrg = yield select(currentOrg);
        yield call(
            deleteDataRequest,
            'deleteSecurity',
            'Deleting security '.concat(payload),
            [ORGID_PATH_PARAM, 'securityId'],
            [selectedOrg ?.id, payload]
        ) || [];
        yield put(onDeleteSecuritySuccess(payload)); // just dispatch the id as the reducer will remove from the item from the list
    } catch (error) {
        yield put(showSecurityMessage(apiErrorMessageFormatter(error)));
    }
}

export function* saveSecurity({ payload }) {
    try {
        const selectedOrg = yield select(currentOrg);
        const allSecuritys = yield select(getSecurityList);
        let finalPayload = { ...payload };
        // check the orgid of the payload - it will be empty for a new payload - populate from the selectedOrg - otherwise leave it as is
        if (!payload ?.orgid) {
            finalPayload = { ...payload, orgid: selectedOrg ?.id };
        }
        const savedSecurity = yield call(
            addOrUpdateDataRequest,
            allSecuritys,
            finalPayload,
            'addSecurity',
            'updateSecurity',
            [ORGID_PATH_PARAM],
            [selectedOrg.id]);
        yield put(onSaveSecuritySuccess(savedSecurity));
    } catch (error) {
        yield put(showSecurityMessage(apiErrorMessageFormatter(error)));
    }
}

/**
 * This is when the user selects the star on the list page - update the starred attribute of the entity
 * @param {*} param0 
 */
export function* addFavouriteSecurity({ payload }) {
    try {
        const allSecuritys = yield select(getSecurityList);
        const selectedOrg = yield select(currentOrg);
        const filtered = allSecuritys.filter((entry) => entry ?.id === payload ?.id);

        if (filtered ?.length > 0) {
            const entry = filtered[0];
            const updatedSecurity = {
                ...entry,
                starred: !payload.starred
            };
            const auditMsg = 'Updating starred setting to '.concat(updatedSecurity ?.starred).concat(' for security ').concat(updatedSecurity ?.id);
            yield call(
                updateDataRequest,
                updatedSecurity,
                'updateSecurity',
                auditMsg,
                [ORGID_PATH_PARAM],
                [selectedOrg.id],
            );
            // now just pass on the original payload as the reducer will filter the list as per the state of the selection
            yield put(addFavouriteSecuritySuccess(payload));
        }
    } catch (error) {
        yield put(showSecurityMessage(error.messages));
    }
}

export function* fetchSecuritysSaga() {
    yield takeEvery(FETCH_ALL_SECURITY, fetchSecuritys);
}

export function* saveSecuritySaga() {
    yield takeEvery(ON_SAVE_SECURITY, saveSecurity);
}

export function* deleteSecuritySaga() {
    yield takeEvery(ON_DELETE_SECURITY, deleteSecurity);
}

export function* addFavouriteSecuritySaga() {
    yield takeEvery(ADD_FAVOURITE_SECURITY, addFavouriteSecurity);
}

export default function* rootSaga() {
    yield all([
        fork(fetchSecuritysSaga),
        fork(saveSecuritySaga),
        fork(deleteSecuritySaga),
        fork(addFavouriteSecuritySaga),
    ]);
}


// WEBPACK FOOTER //
// ./sagas/security.js